import { render, staticRenderFns } from "./ProFundamental.vue?vue&type=template&id=23a73d50&"
import script from "./ProFundamental.vue?vue&type=script&lang=ts&"
export * from "./ProFundamental.vue?vue&type=script&lang=ts&"
import style0 from "./ProFundamental.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports